// Auto-generated from package.json — do not edit manually
export const VERSION = '2.2.0';
